import { AfterViewInit, Component, inject, ViewContainerRef } from '@angular/core';
import { SkeletonLoaderService } from '@skeleton-loader';
import {
  EngravingModalService,
  type EngravingModalData,
} from '../../../../libs/core/src/lib/services/engraving-modal.service';
import {
  AppleCareModalService,
  type AppleCareModalData,
} from '../../../../libs/core/src/lib/services/applecare-modal.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [EngravingModalService, AppleCareModalService],
  standalone: false,
})
export class AppComponent implements AfterViewInit {
  loading = false;

  private skeletonLoaderService = inject(SkeletonLoaderService);
  private viewContainerRef = inject(ViewContainerRef);
  private engravingModalService = inject(EngravingModalService);
  private appleCareModalService = inject(AppleCareModalService);

  isEngravingModalOpen$: Observable<boolean>;
  engravingModalData$: Observable<EngravingModalData | null>;
  isAppleCareModalOpen$: Observable<boolean>;
  appleCareModalData$: Observable<AppleCareModalData | null>;

  constructor() {
    this.isEngravingModalOpen$ = this.engravingModalService.isModalOpen$;
    this.engravingModalData$ = this.engravingModalService.modalData$;

    this.isAppleCareModalOpen$ = this.appleCareModalService.isModalOpen$;
    this.appleCareModalData$ = this.appleCareModalService.modalData$;
  }
  ngAfterViewInit(): void {
    this.skeletonLoaderService.createSkeletonTemplates(this.viewContainerRef);
  }
  onEngravingSave(result: { productId: number; engravingText: string }): void {
    this.engravingModalService.saveEngraving(result.productId, result.engravingText);
  }

  onEngravingClose(): void {
    this.engravingModalService.closeModal();
  }
  onEngravingSkip(): void {
    const currentData = this.engravingModalService.currentModalData;
    if (currentData) {
      this.engravingModalService.skipEngraving(currentData.product.productId);
    }
  }
  // AppleCare Modal Handlers
  onAppleCareClose(): void {
    this.appleCareModalService.closeModal();
  }

  onAppleCareAction(event: any): void {
    if (event.action === 'close') {
      this.onAppleCareClose();
    } else if (event.action === 'learn-more') {
    }
  }
}
